export const getAllThemesFromLists = (
	lists: any,
	policy?: Array<string>,
	sector?: Array<string>
) => {
	let domains = []
	let areas = []
	let sectors = []
	if (policy) {
		policy.forEach(p => {
			const domainKey = getTagCodes(p, 'd')
			if (
				domainKey &&
				lists &&
				lists.policies[domainKey] &&
				domains.indexOf(lists.policies[domainKey].name) < 0
			)
				domains.push(lists.policies[domainKey].name)
			const areaKey = getTagCodes(p, 'a')
			if (
				domainKey &&
				areaKey &&
				lists &&
				lists.policies[domainKey] &&
				lists.policies[domainKey].areas[areaKey]
			)
				areas.push(lists.policies[domainKey].areas[areaKey])
		})
	}
	if (sector) sectors = sector.map(s => lists.sectors[getTagCodes(s, 'k')])
	return domains.concat(areas).concat(sectors)
}

export const getTagCodes = (fullcode: string, searchinCode: string) => {
	const regex = new RegExp('.*' + searchinCode + '([0-9]*).*', 'g')
	return fullcode.replace(regex, '$1')
}
export const getAllTagsFromLists = (tags: Array<string>, lists: any) =>
	tags && lists && tags.map(t => lists.tags[t])

export const getThemesAndTagsFromLists = (
	lists: any,
	policy?: Array<string>,
	sector?: Array<string>,
	tags?: Array<string>
) => {
	return getAllThemesFromLists(lists, policy, sector).concat(
		getAllTagsFromLists(tags, lists)
	)
}
